export default __webpack_public_path__ + "static/media/levenspad_NL_gsm2.c9c69cd9.png";